module.exports = __webpack_public_path__ + "img/thumb_Snail_Mail.88362164.jpg";